import { CHAT_UI_PREFIX } from 'constants/id';
import { kebabCase } from 'lodash';

/**
 * Prefixes HTML `id` attributes and ensures kebab-case IDs.
 * NOTE: Do not use for form field IDs; otherwise it would cause conflicts with the field properties.
 * @param id HTML `id` attribute to wrap
 * @returns object with `id`
 */
const htmlId = (id: string) => {
  return kebabCase(`${CHAT_UI_PREFIX}-${id}`).toLowerCase();
};

export default htmlId;
